import { render, staticRenderFns } from "./guia-detalhe.vue?vue&type=template&id=373b16d6&scoped=true&"
import script from "./guia-detalhe.vue?vue&type=script&lang=js&"
export * from "./guia-detalhe.vue?vue&type=script&lang=js&"
import style0 from "./guia-detalhe.vue?vue&type=style&index=0&id=373b16d6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "373b16d6",
  null
  
)

export default component.exports